import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { filterAndSortBySubgroup } from '../utils';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';
import ProductIncomeYearFieldsPct from './ProductIncomeYearFieldsPct';

const ProductIncomeExtendedPct = () => {
  const { watch } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const productIncomePercentages =
    incomeStructure?.productIncomePercentages || {};
  const productIncomeExtendedPct = filterAndSortBySubgroup(
    productIncomePercentages,
    INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME
  );

  return (
    <>
      {productIncomeExtendedPct.map(([key, item]) => (
        <Flex key={key} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350} justifyItems={'end'}>
            <InputLabel sx={{ textAlign: 'right' }}>
              {item.incomeCategory?.nameTh === ''
                ? 'กรุณาระบุสายผลิตภัณฑ์หรือกลุ่มธุรกิจ'
                : item.incomeCategory?.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ProductIncomeYearFieldsPct keyItem={key} />
        </Flex>
      ))}
    </>
  );
};

export default ProductIncomeExtendedPct;
